export default __webpack_public_path__ + "static/media/hash_banner_bg.1ba76b1b.png";